import { render, staticRenderFns } from "./prolst.vue?vue&type=template&id=68cd3fce&scoped=true"
import script from "./prolst.vue?vue&type=script&lang=js"
export * from "./prolst.vue?vue&type=script&lang=js"
import style0 from "./prolst.vue?vue&type=style&index=0&id=68cd3fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd3fce",
  null
  
)

export default component.exports